/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { GCSBucket } from '../models/GCSBucket';

export class GCSBuckets {
  'buckets': Array<GCSBucket>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "buckets",
      "baseName": "buckets",
      "type": "Array<GCSBucket>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GCSBuckets.attributeTypeMap;
  }

  public constructor() {
  }
}

